var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'color')?_c('div',{style:(_vm.cubeStyle)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }